import Vue from 'vue';
import ElementUI from 'element-ui';
import VueParticles from 'vue-particles';
import App from './App';
import router from './router';
import store from './store';
import services from './services';
import drective from './drective';
import utils from './utils';
import toaster from '@/utils/toaster';
import Notifications from '@/plugs/notifications';
import rightMenu from '@/plugs/rightmenu';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/icon/iconfont.css';
import '@/assets/icon2/iconfont.css';
import '@/assets/icon2/iconfont.js';
// date format filter
import datePipe from './filters/date';

Vue.filter('date', datePipe);

Vue.use(ElementUI);
Vue.use(rightMenu);
Vue.use(VueParticles);
Vue.use(Notifications);
Vue.use(drective);

Vue.config.productionTip = false;
Vue.prototype.$services = services;
Vue.prototype.$utils = utils;
Vue.prototype.$toaster = toaster;

new Vue({
  router,
  store,
  provide: {
    $datePipe: datePipe,
  },
  render: h => h(App),
}).$mount('#app');
